<template>
  <div id="buyModal" class="modal fade buy-modal" tabindex="-1" aria-labelledby="buyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <img src="@/assets/images/logo.svg" alt="Info Global Logo" />
          <button ref="closeButton" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body px-4">
          <!-- <h3 class="title">Заказ на сумму: ₽</h3> -->
          <form class="form">
            <label class="mt-3" for="address">Адрес</label>
            <input id="address" v-model="form.address" class="form-control mt-2" placeholder="Введите адрес" />
            <label class="mt-3" for="postal_code">Почтовый индекс</label>
            <input
              id="postal_code"
              v-model="form.postal_code"
              class="form-control mt-2"
              placeholder="Почтовый индекс адреса"
            />
            <label class="mt-3" for="phone_number">Телефон для связи</label>
            <input
              id="phone_number"
              v-model="form.phone_number"
              class="form-control mt-2"
              type="phone"
              placeholder="Номер телефона"
            />
            <button class="btn btn-primary mt-2 mx-auto d-block" @click.prevent="goToBuy">Перейти к оплате</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, defineComponent } from 'vue';
  import marketplaceService from '@/services/marketplace';

  export default defineComponent({
    name: 'BuyModal',
    components: {},
    setup() {
      const form = ref({
        address: '',
        postal_code: '',
        phone_number: '',
      });

      const goToBuy = () => {
        marketplaceService.getBuyLink(form.value).then((res) => {
          window.location.replace(res.order_url);
        });
      };
      return {
        form,
        goToBuy,
      };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/auth';
</style>
